(function(){
  document.addEventListener('DOMContentLoaded', function() {

    var playButton = document.querySelectorAll('.banner_section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
      }, 100);
    }
    

    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(event) {
        this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
      }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);
    
    /*
    * start code for hover menu open
    */
    const inlineMenu = document.querySelector(".header__inline-menu");
    const detailsItems = inlineMenu.querySelectorAll("details");
      detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul.mega-menu__list");
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
          item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        });
      });
     /*
    * end start code for hover menu open
    */
    
    document.addEventListener('click', function(e) {
      if ((e.target.classList.contains('complementary_item') || e.target.closest('.complementary_item')) && e.target.closest('product-recommendations')  && ! e.target.closest('.card__content')) {
        let $this = e.target.classList.contains('complementary_item') ? e.target : e.target.closest('.complementary_item');
        // console.log($this);
        $this.classList.toggle('active');
      }
    });

    document.addEventListener('click', function(e) {
      if ((e.target.classList.contains('add_look_to_cart') || e.target.closest('.add_look_to_cart')) && e.target.closest('product-recommendations') && ! e.target.closest('.card__content')) {
        let $this = e.target.classList.contains('add_look_to_cart') ? e.target : e.target.closest('.add_look_to_cart');
        e.preventDefault();
        let parentThis = $this.closest('aside');
        let formData = {'items': []};
        let productsItems = parentThis.querySelectorAll('.complementary_item.active .product-variant-id');
        
        productsItems.forEach( item => {
          let productID = item.value;
          formData.items.push({'id': productID,'quantity': 1});
        });
        console.log(formData);
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          console.log(response);
            if ( response.status == 200 ) {
              $.ajax({
                url: '/?section_id=cart-drawer',
                type: 'GET',
                dataType: 'html',
                success: function(carthtml) {
                  let cartDraw = document.querySelector('cart-drawer');
                  let tempElem = document.createElement('div');
                  tempElem.innerHTML = carthtml;
                  let cartNewContent = tempElem.querySelector('.drawer').innerHTML;
                  cartDraw.innerHTML = cartNewContent;
                  cartDraw.classList.remove('is-empty');
                  cartDraw.classList.add('active');
                  document.querySelector('body').classList.add('overflow-hidden');
                  document.querySelector('quick-add-modal[open]')?.removeAttribute('open');
                  let cartCounter = document.querySelector('#cart-icon-bubble');
                  let cartCounterBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
                  let itemsSize = document.querySelectorAll('#CartDrawer-CartItems .cart-item').length;
                  if ( cartCounterBubble ) {
                    let textCounter = `<span aria-hidden="true">${itemsSize}</span><span class="visually-hidden">${itemsSize} items</span>`;
                    cartCounterBubble.innerHTML = textCounter;
                  } else {
                    let counter = document.createElement('div');
                    let textCounter = `<div class="cart-count-bubble"><span aria-hidden="true">${itemsSize}</span><span class="visually-hidden">${itemsSize} items</span></div>`;
                    cartCounter.insertAdjacentHTML('beforeend', textCounter);
                  }
                }
              });
            } else {
              alert('Something goes wrong, write to support.');
            }
          
        })
        .catch((error) => {
          console.error('Error:', error);
        })
      }
    });

    /*
    * code for close menu mobile
    */
    let closeMenuCustom = document.querySelector('.close_menu');
    closeMenuCustom.addEventListener('click', function(e) {
      e.preventDefault();
      let HD = this.closest('header-drawer');
      let HDIcon = HD.querySelector('summary.header__icon');
      HDIcon.click();
    });

    
    window.tempInputs = [];
    document.addEventListener('change', function(e) {
      if (e.target.matches('quick-add-modal variant-selects [type="radio"]')) {
          console.log('Изменение в текстовом поле:', e.target.id);
        if ( ! window.tempInputs.includes(e.target.id) ) {
          window.tempInputs.push(e.target.id);
        }
        
      }
    });
    document.addEventListener('click', function(e) {
      if ( e.target.matches('quick-add-modal variant-selects [type="radio"] + label') || e.target.closest('label.swatch-input__label')) {
        
       let idInput;
        if ( e.target.closest('label.swatch-input__label') ) {
          idInput = e.target.closest('label.swatch-input__label').getAttribute('for');
        } else {
          idInput = e.target.getAttribute('for');
        }
        
        let targetId = document.querySelector(`#${idInput}`).getAttribute('id');
          console.log('Изменение в текстовом поле:', targetId);
        if ( ! window.tempInputs.includes(targetId) ) {
          window.tempInputs.push(targetId);
        }
        e.target.closest('fieldset').classList.add('active');

        let anotherFieldset = document.querySelectorAll('quick-add-modal variant-selects fieldset:not(.active) [type="radio"]:checked');
        
        let alreadyFilledInput = document.querySelector(`#${idInput}:checked`);
        if ( anotherFieldset && alreadyFilledInput ) {
          anotherFieldset.forEach( elem => {
            elem.removeAttribute('checked');
          });
        }
        
      }
    });

    
  }, false);
})();

